/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { getColor } from '@airasia-phoenix/react-native/utils/utils';

export const styles = StyleSheet.create((pd) => ({
  containerMobile: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    backgroundColor: getColor(pd.sys.colour.bg_primary),
    zIndex: 1,
  },
  container: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingVertical: 16,
    marginHorizontal: 'auto',
    paddingHorizontal: {
      xs: 16,
      sm: 16,
      md: 16,
      lg: 24,
      xl: 24,
      superLarge: '8.5%',
    },
    backgroundColor: getColor(pd.sys.colour.bg_primary),
    zIndex: 1,
  },
  // Padding-only override for LOBs whose header sits closer to the viewport
  // edge than the default 8.5% gutter (WebHeaderViewProps.compactHorizontalPadding).
  // Kept inside the stylesheet rather than inlined at the call site so unistyles
  // still resolves the breakpoint object; only superLarge differs from container.
  containerCompactPadding: {
    paddingHorizontal: {
      xs: 16,
      sm: 16,
      md: 16,
      lg: 24,
      xl: 24,
      superLarge: '3%',
    },
  },
  moveLogo: {
    flexShrink: 0,
    marginRight: 16,
    width: 150,
  },
  mobileMoveLogo: {
    position: 'absolute',
    left: 0,
    right: 0,
    alignItems: 'center',
  },
  content: {
    flex: 1,
    flexShrink: 1,
    overflow: 'hidden',
  },
  endSection: {
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'center',
  },
  navigationBar: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    minHeight: 38,
  },
  navItem: {
    marginHorizontal: pd.ref.space.spacing20.px,
  },
  navItemLastItem: {
    marginStart: pd.ref.space.spacing20.px,
    marginEnd: 0,
  },
  dividerWrapper: {
    paddingHorizontal: pd.ref.space.spacing40.px,
  },
  localeCurrencyBtn: {
    marginHorizontal: pd.ref.space.spacing20.px,
    flexDirection: 'row',
    alignItems: 'center',
  },
  localeCurrencySplit: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  localeCurrencySplitBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: pd.ref.space.spacing10.px,
  },
  localeCurrencyIcon: {
    marginLeft: pd.ref.space.spacing10.px,
  },
  account: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  accountWrapper: {
    position: 'relative',
  },
  accountLabel: {
    marginLeft: pd.ref.space.spacing20.px,
  },
  accountTextParent: {
    'white-space': 'nowrap',
    'text-overflow': 'ellipsis',
    overflow: 'hidden',
    maxWidth: {
      xs: 80,
      md: 100,
      lg: 120,
    },
  },
  accountSkeleton: {
    marginLeft: pd.ref.space.spacing20.px,
    width: 45,
    height: 20,
    borderRadius: 10,
  },
  mobileAccount: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  mobileAccountText: {
    marginLeft: pd.ref.space.spacing20.px,
    maxWidth: 80,
  },
  mobileAccountSkeleton: {
    marginLeft: pd.ref.space.spacing20.px,
    width: 45,
    height: 20,
    borderRadius: 10,
  },
  mobileRight: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: pd.ref.space.spacing20.px,
  },
  mobileLocaleCurrencyWrapper: {
    position: 'relative',
    alignSelf: 'stretch',
    justifyContent: 'center',
  },
  mobileLocaleCurrency: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: pd.ref.space.spacing10.px,
  },
  mobileDarkMode: {
    alignItems: 'center',
  },
  pickerContainer: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: -pd.ref.space.spacing20.px,
    zIndex: 100,
    borderRadius: pd.sys.shape.corner.large.bottomEnd,
    borderWidth: 1,
    borderColor: getColor(pd.sys.colour.outline_low),
    backgroundColor: getColor(pd.sys.colour.container_none),
    paddingVertical: pd.ref.space.spacing10.px,
    overflow: 'hidden',
    minWidth: 200,
  },
}));
